import { Select, SelectInstance, SelectOption, TooltipV2 } from '@cimplico/components';
import { Ref, useEffect, useState } from 'react';
import { Entity } from '../../types/entity';

type TrialBalanceProviderSelectProps = {
    defaultProvider?: string;
    entity?: Entity;
    onChange: (provider?: string) => void;
    innerRef?: Ref<SelectInstance>;
};

function TrialBalanceProviderSelect({ defaultProvider, entity, onChange, innerRef }: TrialBalanceProviderSelectProps): JSX.Element {
    const [selected, setSelected] = useState<string | undefined>(defaultProvider);

    function handleProviderChange(options: SelectOption[]): void {
        if (options.length === 0) {
            setSelected(undefined);
            onChange(undefined);
        } else {
            setSelected(options.map((o) => o.value as string)[0]);
            onChange(options.map((o) => o.value as string)[0]);
        }
    }

    useEffect(() => {
        setSelected(defaultProvider);
    }, [defaultProvider]);

    return (
        <TooltipV2 message="Please select an entity" disabled={!!entity}>
            <Select
                isDisabled={!entity}
                placeholder="Select a provider..."
                onChange={(options): void => {
                    handleProviderChange(options);
                }}
                options={[
                    {
                        value: 'xero',
                        label: 'Xero',
                        isSelected: selected === 'xero',
                        isDisabled: !entity || entity.integrations.xero === null,
                        disabledHint:
                            'Unable to use Xero as a trial balance source as the integration is not active. Go to the Integrations tab on the Entity Overview screen to configure the integration.',
                    },
                    {
                        value: 'csv',
                        label: 'Import',
                        isSelected: selected === 'csv',
                        isDisabled: !entity,
                    },
                ]}
                ref={innerRef}
            />
        </TooltipV2>
    );
}
export default TrialBalanceProviderSelect;
